import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthAPI } from "../services/api";

declare global {
  interface Window {
    chrome?: {
      webview?: {
        postMessage: (message: string) => void;
      };
    };
  }
}

const BaevrDesktopLogin: React.FC = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();

    setError("");

    if (!email.trim()) {
      setError("Please enter your email address.");
      return;
    }

    if (!password) {
      setError("Please enter your password.");
      return;
    }

    try {
      setLoading(true);

      // =========================================================
      // CALL BAeVR BACKEND LOGIN
      // =========================================================

      const response = await AuthAPI.login(
        email.trim(),
        password
      );

      console.log(
        "========== LOGIN RESPONSE =========="
      );

      console.log(
        JSON.stringify(response.data, null, 2)
      );

      console.log(
        "===================================="
      );

      const token = response.data?.token;
      const user = response.data?.user;

      // =========================================================
      // CHECK TOKEN
      // =========================================================

      if (!token) {
        setError(
          "Login successful, but authentication token was not received."
        );
        return;
      }

      // =========================================================
      // CHECK USER
      // =========================================================

      if (!user) {
        setError(
          "Login successful, but user information was not received."
        );
        return;
      }

      // =========================================================
      // GET USER NO
      // =========================================================

      const userNo =
        user?.UserNo ??
        user?.userNo ??
        0;

      // =========================================================
      // GET USER NAME
      // =========================================================

      const userName =
        user?.UserName ??
        user?.userName ??
        "";

      // =========================================================
      // DEBUG USER INFORMATION
      // =========================================================

      console.log(
        "========== USER INFORMATION =========="
      );

      console.log(
        "User Object:",
        user
      );

      console.log(
        "UserNo:",
        userNo
      );

      console.log(
        "UserName:",
        userName
      );

      console.log(
        "Companies:",
        user?.companies
      );

      console.log(
        "======================================"
      );

      // =========================================================
      // CHECK USER NO
      // =========================================================

      if (!userNo || userNo <= 0) {
        setError(
          "Login successful, but valid user information was not received."
        );
        return;
      }

      // =========================================================
      // GET USER'S COMPANIES
      // =========================================================

      const companies =
        user?.companies ?? [];

      // =========================================================
      // CHECK COMPANIES
      // =========================================================

      if (!companies.length) {
        setError(
          "Login successful, but no company was assigned to this user."
        );
        return;
      }

      // =========================================================
      // DEBUG COMPANY INFORMATION
      // =========================================================

      console.log(
        "========== COMPANY INFORMATION =========="
      );

      console.log(
        "Companies:",
        companies
      );

      console.log(
        "Company Count:",
        companies.length
      );

      console.log(
        "========================================="
      );

      // =========================================================
      // STORE AUTHENTICATION TOKEN
      // =========================================================

      localStorage.setItem(
        "authToken",
        token
      );

      // =========================================================
      // STORE LOGGED-IN USER
      // =========================================================

      localStorage.setItem(
        "user",
        JSON.stringify(user)
      );

      // =========================================================
      // ONE COMPANY
      //
      // If the user has only one company,
      // automatically continue to VB.NET.
      // =========================================================

      if (companies.length === 1) {

        const company = companies[0];

        const loginMessage =
          JSON.stringify({
            type: "BAEVR_LOGIN_SUCCESS",

            token: token,

            userNo: userNo,

            userName: userName,

            companyNo:
              company.companyNo,

            userType:
              company.userType ?? "",
          });

        console.log(
          "========== ONE COMPANY =========="
        );

        console.log(
          "Selected Company:",
          company
        );

        console.log(
          "Sending to VB.NET:",
          loginMessage
        );

        console.log(
          "================================="
        );

        // =======================================================
        // SEND SELECTED COMPANY TO VB.NET
        // =======================================================

        if (window.chrome?.webview) {

          window.chrome.webview.postMessage(
            loginMessage
          );

        } else {

          console.warn(
            "WebView2 environment not detected. Login information was not sent to VB.NET."
          );

        }

        return;
      }

      // =========================================================
      // MULTIPLE COMPANIES
      //
      // Do NOT send the companies directly to VB.NET.
      //
      // Open the React company-selection screen instead.
      // =========================================================

      console.log(
        "========== MULTIPLE COMPANIES =========="
      );

      console.log(
        "Company Count:",
        companies.length
      );

      console.log(
        "Opening company selection screen..."
      );

      console.log(
        "========================================"
      );

      navigate(
        "/baevr-company-selection",
        {
          state: {
            token: token,

            userNo: userNo,

            userName: userName,

            companies: companies,
          },
        }
      );

      return;

    } catch (err: any) {

      console.error(
        "LOGIN ERROR:",
        err
      );

      const message =
        err?.response?.data?.message ||
        err?.response?.data ||
        "Invalid email or password.";

      setError(
        typeof message === "string"
          ? message
          : "Invalid email or password."
      );

    } finally {

      setLoading(false);

    }
  };


  // =========================================================
  // UI
  // =========================================================

  return (
    <div
      style={{
        minHeight: "100vh",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#f5f6fa",
        boxSizing: "border-box",
      }}
    >

      <div
        style={{
          width: "400px",
          backgroundColor: "#ffffff",
          padding: "35px",
          borderRadius: "8px",
          boxShadow:
            "0 4px 20px rgba(0,0,0,0.10)",
          boxSizing: "border-box",
        }}
      >

        {/* =====================================================
            BAeVR TITLE
        ===================================================== */}

        <h2
          style={{
            textAlign: "center",
            margin: "0 0 8px 0",
            color: "#53538c",
            fontSize: "24px",
            fontWeight: 600,
          }}
        >
          BAeVR
        </h2>

        <p
          style={{
            textAlign: "center",
            color: "#666666",
            margin: "0 0 30px 0",
            fontSize: "15px",
          }}
        >
          Desktop Login
        </p>


        {/* =====================================================
            LOGIN FORM
        ===================================================== */}

        <form onSubmit={handleLogin}>

          {/* ===================================================
              EMAIL
          =================================================== */}

          <div
            style={{
              marginBottom: "20px",
            }}
          >

            <label
              style={{
                display: "block",
                marginBottom: "7px",
                color: "#333333",
                fontSize: "14px",
                fontWeight: 500,
              }}
            >
              Email Address
            </label>

            <input
              type="email"
              value={email}
              onChange={(e) =>
                setEmail(e.target.value)
              }
              placeholder="Enter your email"
              autoComplete="username"
              disabled={loading}
              style={{
                display: "block",
                width: "100%",
                height: "42px",
                padding: "0 12px",
                boxSizing: "border-box",

                border:
                  "1px solid #d5d7df",
                borderRadius: "6px",

                backgroundColor: loading
                  ? "#f5f5f5"
                  : "#ffffff",

                color: "#222222",

                outline: "none",
                fontSize: "14px",
                fontFamily:
                  "Segoe UI, Arial, sans-serif",
              }}
            />

          </div>


          {/* ===================================================
              PASSWORD
          =================================================== */}

          <div
            style={{
              marginBottom: "15px",
            }}
          >

            <label
              style={{
                display: "block",
                marginBottom: "7px",
                color: "#333333",
                fontSize: "14px",
                fontWeight: 500,
              }}
            >
              Password
            </label>

            <input
              type="password"
              value={password}
              onChange={(e) =>
                setPassword(e.target.value)
              }
              placeholder="Enter your password"
              autoComplete="current-password"
              disabled={loading}
              style={{
                display: "block",
                width: "100%",
                height: "42px",
                padding: "0 12px",
                boxSizing: "border-box",

                border:
                  "1px solid #d5d7df",
                borderRadius: "6px",

                backgroundColor: loading
                  ? "#f5f5f5"
                  : "#ffffff",

                color: "#222222",

                outline: "none",
                fontSize: "14px",
                fontFamily:
                  "Segoe UI, Arial, sans-serif",
              }}
            />

          </div>


          {/* ===================================================
              ERROR
          =================================================== */}

          {error && (
            <div
              style={{
                marginBottom: "15px",
                padding: "10px",
                borderRadius: "5px",
                backgroundColor: "#fff1f1",
                border:
                  "1px solid #f0b5b5",
                color: "#c62828",
                fontSize: "13px",
              }}
            >
              {error}
            </div>
          )}


          {/* ===================================================
              LOGIN BUTTON
          =================================================== */}

          <button
            type="submit"
            disabled={loading}
            style={{
              display: "block",
              width: "100%",
              height: "42px",
              border: "none",
              borderRadius: "6px",

              backgroundColor: loading
                ? "#9999bb"
                : "#53538c",

              color: "#ffffff",

              fontSize: "14px",
              fontWeight: 600,
              fontFamily:
                "Segoe UI, Arial, sans-serif",

              cursor: loading
                ? "not-allowed"
                : "pointer",
            }}
          >
            {loading
              ? "Signing In..."
              : "Login"}
          </button>

        </form>

      </div>

    </div>
  );
};

export default BaevrDesktopLogin;